import styled from 'styled-components'

export const FieldType = styled.span`
  flex: 0 0 115px;
  @media (min-width: 600px) {
    width: 115px;
  }
`

export const FieldValue = styled.span`
  font-weight: 700;
  text-transform: uppercase;
  text-align: right;
`

export const FieldValuePrimary = styled(FieldValue)`
  font-size: 1.4em;
`

export const InvoiceDetail = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  line-height: 1.25;

  @media (min-width: 600px) {
    justify-content: flex-start;
  }
`

export const FieldValuesSection = styled.div`
  margin-bottom: 16px;
`

export const HorizontalRule = styled.hr`
  color: ${({ theme }) => theme.colors.coolGray.cool450};
  border-style: solid;
  border-bottom: none;
  @media print {
    max-width: 100%;
  }
`
